export default __webpack_public_path__ + "static/media/male-mesomorph.8a78bc70.svg";